<section class="header-content">
  <app-page-title [type]="type"></app-page-title>

  @if (editMode()) {
    <div class="btn-edit">
      <button class="button" (click)="onAddItem()">Add Item</button>
      <button class="button" (click)="onAddGallery()">Add Gallery</button>
    </div>
  }
</section>
@for (article of articles; track article.id) {
  <app-gallery-article [article]="article" (deleted)="onDeleted($event)"></app-gallery-article>
}
